export const IS_DEV =
    import.meta.env.VITE_APP_ENVIRONMENT === 'development' ||
    import.meta.env.VITE_APP_ENVIRONMENT === 'local';

export const FILE_STORAGE_ENDPOINT = import.meta.env.VITE_APP_FILE_STORAGE_ENDPOINT;
export const GRAPHQL_ENDPOINT = import.meta.env.VITE_APP_GRAPHQL_HTTP_ENDPOINT;
export const GRAPHQL_WS_ENDPOINT = import.meta.env.VITE_APP_GRAPHQL_WS_ENDPOINT;
export const DJANGO_API = import.meta.env.VITE_APP_DJANGO_API_ENTRYPOINT;

export const PLAID_ENTRYPOINT = DJANGO_API + '/plaid';
export const TREASURY_PRIME_ENTRYPOINT = DJANGO_API + '/treasuryprime';
export const MODERN_TREASURY_ENTRYPOINT = DJANGO_API + '/modern_treasury';
export const PHONE_VERIFICATION_ENTRYPOINT = DJANGO_API + '/phone';
export const EMPLOYEE_UPDATE_ENTRYPOINT = DJANGO_API + '/employee';
export const INVESTOR_ENTRYPOINT = DJANGO_API + '/investor';
export const INVESTOR_SECONDARY = DJANGO_API + '/secondary_investor';
export const BUSINESS_COOWNER = DJANGO_API + '/business_coowner';
export const BUSINESS_COWORKER_ENTRYPOINT = DJANGO_API + '/business_coworker';
export const BUSINESS_ENTRYPOINT = DJANGO_API + '/business';
export const SIGNWELL_ENTRYPOINT = DJANGO_API + '/signwell';
export const EMAILS_ENTRYPOINT = DJANGO_API + '/email';
export const DEAL_ENTRYPOINT = DJANGO_API + '/deal';
export const DOCUMENT_ENTRYPOINT = DJANGO_API + '/documents';
export const POS_ENTRYPOINT = DJANGO_API + '/pos';
export const QUICKBOOKS_ENTRYPOINT = DJANGO_API + '/accounting/intuit';
export const CRS_ENTRYPOINT = DJANGO_API + '/crs';
export const MONEYTHUMB_ENTRYPOINT = DJANGO_API + '/moneythumb';
export const DEAL_TRANSFER_ENTRYPOINT = DJANGO_API + '/deal_transfer';
export const COWORKER_ENTRYPOINT = DJANGO_API + '/coworker';
export const UNDERWRITING_ENTRYPOINT = DJANGO_API + '/underwriting';
export const DEAL_REQUESTS_ENTRYPOINT = DJANGO_API + '/deal_requests';
export const SERVICING_ENTRYPOINT = DJANGO_API + '/servicing';
export const CLOSING_ENTRYPOINT = DJANGO_API + '/closing';
export const CLOSING_DOCUMENT_UPLOAD_ENTRYPOINT = DJANGO_API + '/closing_documents';
export const SPV_ENTRYPOINT = DJANGO_API + '/spv';
export const DEAL_PRIVATE_DOCUMENTS_ENTRYPOINT = DJANGO_API + '/deal_private_documents';
export const GLOBAL_SETTINGS_ENTRYPOINT = DJANGO_API + '/global_settings';

export const baseURL = new URL(import.meta.env.BASE_URL, window.origin);
export const buildInfoURL = new URL('/build-info.json', baseURL);

export const ENABLE_QUICKBOOKS = ['True', 'true', '1', 'on'].includes(
    import.meta.env.VITE_APP_ENABLE_QUICKBOOKS
);

export const ENABLE_POS_CONNECTIONS = false;
